import { createAsyncAction } from 'Helpers/redux'
import React from 'react'
import { Error, TikTokTrack } from 'Types/index'
import { APP } from 'Configs/App'
import { apiCall } from './api'

export const GET_SPOTIFY_TRACK = createAsyncAction('GET_SPOTIFY_TRACK')
export const getSpotifyTrack = (
  url: string,
  token: string,
  callback: (
    error: Error,
    res: {
      name: string
      duration_ms: number
      id: string
      artists: { name: string }[]
    }
  ) => void
) =>
  apiCall({
    method: 'get',
    endpoint: url,
    headers: { Authorization: `Bearer ${token}` },
    types: GET_SPOTIFY_TRACK,
    callback,
  })

export const SET_TRACK_TO_INITIAL_STATE = 'SET_TRACK_TO_INITIAL_STATE'
export const setTrackToInitialState = () => ({
  type: SET_TRACK_TO_INITIAL_STATE,
  payload: null,
})

export const GET_SPOTIFY_TRACKS = createAsyncAction('GET_SPOTIFY_TRACKS')
export const getSpotifyTracks = (
  url: string,
  token: string,
  callback: (error: Error) => void
) =>
  apiCall({
    method: 'get',
    endpoint: url,
    headers: { Authorization: `Bearer ${token}` },
    types: GET_SPOTIFY_TRACKS,
    callback,
  })

export const SET_TRACKS_TO_INITIAL_STATE = 'SET_TRACKS_TO_INITIAL_STATE'
export const setTracksToInitialState = () => ({
  type: SET_TRACKS_TO_INITIAL_STATE,
  payload: null,
})

export const SET_ARTISTS_TO_INITIAL_STATE = 'SET_ARTISTS_TO_INITIAL_STATE'
export const setArtistsToInitialState = () => ({
  type: SET_ARTISTS_TO_INITIAL_STATE,
  payload: null,
})
export const GET_TIKTOK_TRACK = createAsyncAction('GET_TIKTOK_TRACK')

export const getTikTokTrack = (
  search: string,
  callback: (
    error: Error,
    payload: React.SetStateAction<TikTokTrack | null>
  ) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/artist/tiktok/tiktok-track-info`,
    query: {
      params: {
        search,
      },
    },
    types: GET_TIKTOK_TRACK,
    callback,
  })

export const GET_TIKTOK_TRACK_WITHOUT_AUTH = createAsyncAction(
  'GET_TIKTOK_TRACK_WITHOUT_AUTH'
)

export const getTikTokTrackWithoutAuth = (
  search: string,
  callback: (
    error: Error,
    payload: React.SetStateAction<TikTokTrack | null>
  ) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/no_auth/artist/tiktok/tiktok-track-info`,
    query: {
      params: {
        search,
      },
    },
    types: GET_TIKTOK_TRACK_WITHOUT_AUTH,
    callback,
  })

export const SET_TIKTOK_TRACK = 'SET_TIKTOK_TRACK'

export const setTikTokToTrack = (payload: boolean) => ({
  type: SET_TIKTOK_TRACK,
  payload,
})
